import { ref } from "#imports";
import type { IShipment } from "~/types/shipment";

// Shared state
export const loading = ref(false);
export const open = ref(false);
export const noTransferOpen = ref(false);
export const mode = ref<"new" | "duplicate" | "return">("new");
export const return_shipment = ref<IShipment | null>(null);

/**
 * Extracts phone prefix from an object
 */
export const getPhonePrefixFromObject = (prefix: any): string => {
  if (typeof prefix === "object" && prefix !== null) {
    return prefix.prefix || "";
  }
  return prefix || "";
};

/**
 * Checks if a shipment is redacted (has sensitive information removed)
 */
export const isShipmentRedacted = (shipment: IShipment): boolean => {
  return !!shipment.redacted;
};

/**
 * Builds carrier product service string from shipment
 */
export const buildCps = (shipment: IShipment): string => {
  return `${shipment.carrier}_${shipment.carrier_product}_${shipment.carrier_service}`;
};

/**
 * Transforms extra services for selection in form
 */
export const transformExtraServicesForSelection = (services: any[]): Record<string, any> => {
  if (!services || !Array.isArray(services)) return {};

  const transformed: Record<string, any> = {};

  services.forEach((service: any) => {
    if (service.carrier_key && /^([A-Z0-9]{3})$/.test(service.carrier_key)) {
      transformed[service.carrier_key] = { isSet: true };

      if (service.extra_fields && service.extra_fields.length > 0) {
        service.extra_fields.forEach((field: any) => {
          if (field.key && field.value) {
            transformed[service.carrier_key][field.key] = field.value;
          }
        });
      }
    }
  });

  return transformed;
};
